// extracted by mini-css-extract-plugin
export default {"wrapper":"_3991dccc","tileContainer":"_20156b2c","label":"_c5187339"};